import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ExpenseService {

    // getfeestype

    static getExpense(item) {

        let api = `${API_BASE_URL}${API_PATHS.getExpense}`;
        const params = new URLSearchParams();

        params.append("limit", item?.limit || 25);
        params.append("page", item?.page || 1);

        if (item?.id) params.append("id", item.id);
        if (item?.fromDate) params.append("fromDate", item.fromDate);
        if (item?.toDate) params.append("toDate", item.toDate);
        if (item?.q) params.append("q", item.q);
        if (item?.session) params.append("session", item.session);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }


    static addExpense(data) {


        const api = `${API_BASE_URL}${API_PATHS.addExpense}`;
        return axiosInstance
            .post(api, data)

    }

    static editfeestype(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editfeeType}`;
        return axiosInstance
            .put(api, data)

    }



}

export default ExpenseService;
